import React, { Component } from 'react';
import './index.scss';

import Card from 'material-ui/Card';
import Grid from 'material-ui/Grid';
import SumChart from "./sumChart";
import {observer,inject} from 'mobx-react';

@inject("summaryDataStore")
@observer
class CardSummary extends Component {

    constructor(props) {
        super(props)
        this.state = {
            money: 560,
        }
    }

    render() {
        // const { money } = this.state;
        const { bathValue, co2Value, treeValue, percentSave } = this.props.summaryDataStore;
        return (
            <Card className='cardSummary'>
                <Grid container className='containerGrid' justify='center' spacing={0}>
                    {/*<Grid xs={1} sm={1} md={1}></Grid>*/}
                    <Grid xs={10} sm={10} md={10}>
                        <br/>
                        <h1 className='headerCard'>ประหยัดค่าไฟฟ้าได้มากถึง</h1>
                        <SumChart percentSave={percentSave} />
                        <br/>
                        <div>
                            <span className='header'>หากคิดเป็นเงิน คุณจะประหยัด</span>
                            <p className='money'>{ this.props.summaryDataStore.format_(bathValue) }</p>
                            <span className='unit'>บาท/ปี*</span>
                        </div>
                        <br/>
                        <br/>
                        <br/>
                        <Grid container className='containerGrid' spacing={0}>
                            <Grid xs={5} sm={5} md={5} >
                                <Grid container className='containerGrid' spacing={0}>
                                    <Grid xs={4} sm={4} md={5} style={{display:'flex',alignItems:'center',justifyContent:'center'}}>
                                        <img src='assets/icons8-cosmetic_soap.png' alt='cosmetic_soap' className='iconSave' />
                                    </Grid>
                                    <Grid xs={7} sm={7} md={6}>
                                        <div className='sumSave'>
                                            <span>ช่วยลด CO2</span>
                                            <br/>
                                            <span className='textSave'> { this.props.summaryDataStore.format1(co2Value) } </span>
                                            <br/>
                                            <span className='unitSave'>ตัน ใน 1 ปี</span>
                                        </div>
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Grid xs={1} sm={1} md={1}></Grid>
                            <Grid xs={5} sm={5} md={5}>
                                <Grid container className='containerGrid' spacing={0}>
                                    <Grid xs={4} sm={4} md={5} style={{display:'flex',alignItems:'center',justifyContent:'center'}}>
                                        <img src='assets/icons8-deciduous_tree.png' alt='deciduous_tree' className='iconSave' />
                                    </Grid>
                                    <Grid xs={7} sm={7} md={6}>
                                        <div className='sumSave'>
                                            <span>ทดแทนต้นไม้</span>
                                            <br/>
                                            <span className='textSave'> { this.props.summaryDataStore.format1(treeValue) }  </span>
                                            <br/>
                                            <span className='unitSave'>ต้น ใน 1 ปี</span>
                                        </div>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                        {/*<br/>*/}
                        {/*<Grid xs={12} sm={12} md={10} className='warning'>*/}
                            {/*<span>*หมายเหตุ</span>*/}
                            {/*<br/>*/}
                            {/*<span>1. ตัวอย่างหมายเหตุที่ 1</span>*/}
                            {/*<br/>*/}
                            {/*<span>2. ตัวอย่างหมายเหตุที่ 2</span>*/}
                        {/*</Grid>*/}
                        <br/>
                    </Grid>
                </Grid>
            </Card>
        );
    }
}

export default CardSummary;



// WEBPACK FOOTER //
// ./src/components/summary/cardSummary.js